import axios from "axios";
import { persistor } from "../store";
import * as serviceWorkerRegistration from "../serviceWorkerRegistration";

const SHARED_CACHE_KEYS = [
  "pending_employee_booking",
  "driver_active_booking",
  "bubble_position",
  "hire_bubble_position",
];

const ROLE_KEY_PREFIXES = {
  admin: ["admin_"],
  employee: ["employee_", "pending_employee_"],
  driver: ["driver_", "hire_", "bubble_"],
};

export const clearDashboardCache = (role = "") => {
  const normalizedRole = String(role || "").toLowerCase();
  const prefixes = ROLE_KEY_PREFIXES[normalizedRole] || [];
  const removedKeys = [];

  // Clear role-specific and shared keys
  const keys = Object.keys(localStorage);
  for (const key of keys) {
    const isSharedKey = SHARED_CACHE_KEYS.includes(key);
    const isRoleKey = prefixes.some((prefix) => key.startsWith(prefix));
    if (isSharedKey || isRoleKey) {
      localStorage.removeItem(key);
      removedKeys.push(key);
    }
  }

  // FIX: Also clear redux-persist and auth keys
  localStorage.removeItem("persist:root");
  localStorage.removeItem("authKey");

  // FIX: Clear axios auth header
  delete axios.defaults.headers.common["auth-key"];

  sessionStorage.clear();

  return removedKeys;
};

// NEW: Full logout cache wipe — call this on logout instead of clearDashboardCache alone
export const clearAllCacheOnLogout = async (role = "") => {
  clearDashboardCache(role);

  // Purge redux-persist store
  try {
    await persistor.purge();
  } catch (e) {
    console.warn("Persistor purge failed:", e);
  }

  // Unregister service worker so mobile browsers don't serve stale cache
  try {
    serviceWorkerRegistration.unregister();

    // Also clear all SW caches directly
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }
  } catch (e) {
    console.warn("Service worker cleanup failed:", e);
  }
};
